import WResultsCompareDetailsMobile from './WAboutCompareDetailsMobile'

export default WResultsCompareDetailsMobile
